import {Component, computed, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonModule} from 'primeng/button';

@Component({
  selector: 'app-project-banner',
  imports: [CommonModule, ButtonModule],
  templateUrl: './project-banner.component.html',
  styleUrls: ['./project-banner.component.scss'],
})
export class ProjectBannerComponent {
  readonly stepTitle = input('');
  backgroundImage = input<string>('');

  readonly showNavigation = input(false);

  readonly navigatePrev = output<void>();
  readonly navigateNext = output<void>();

  backgroundImageUrl = computed(() => {
    const bgImage = this.backgroundImage();
    return bgImage ? `url('${bgImage}')` : `url('/images/project-chapter-default-bg.jpg')`;
  });

  onPrev(): void {
    this.navigatePrev.emit();
  }

  onNext(): void {
    this.navigateNext.emit();
  }
}
